'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Google = function Google(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: 'Share on Google+', width: width, href: link, onClick: link ? undefined : _Actions2.default['google']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width }, props, { viewBox: '0 0 33 33' }),
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(.206 1)' },
        _react2.default.createElement('ellipse', { cx: '15.914', cy: '15.606', rx: '15.599', ry: '15.606' }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(5.987 9.458)' },
          _react2.default.createElement('path', { d: 'M6.234 5.302V7.4h3.535c-.142.9-1.068 2.64-3.535 2.64a3.87 3.87 0 0 1-3.865-3.864 3.87 3.87 0 0 1 3.865-3.864c1.21 0 2.021.507 2.484.944l1.692-1.6C9.324.66 7.917.056 6.234.056 2.787.056 0 2.793 0 6.176s2.787 6.12 6.234 6.12c3.597 0 5.984-2.483 5.984-5.98 0-.402-.044-.708-.098-1.014H6.234z' })
        ),
        _react2.default.createElement('path', { d: 'M25.84 15.133h-1.89v-1.892h-1.891v1.892h-1.89v1.892h1.89v1.891h1.89v-1.891h1.891z' })
      )
    )
  );
};

Google.defaultProps = {
  title: "Share on Google+"
};

exports.default = Google;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Google.js
// module id = 441
// module chunks = 168707334958949